export default [
  {
    path      : '/404',
    name      : '404',
    component : () => import('@/views/ErrorPage/404.vue')
  }
]
